import React, { FC } from 'react';
import ErrorLoadingDetailProperty from 'components/shared/detail/ErrorLoadingDetailProperty';
import Skeleton from 'react-loading-skeleton';
import { STATUS } from '@kontentino/kontentino-constants/Posts';
import AccordionWidgetIcon from 'app/modules/posts/components/accordionWidget/AccordionWidgetIcon';
import AccordionWidget from 'app/modules/posts/components/AccordionWidget';
import AccordionWidgetTitle from 'app/modules/posts/components/accordionWidget/AccordionWidgetTitle';
import { Chip } from '@kontentino/ui';
import TodoItem from '../beforeScheduleTodo/TodoItem';
import { PostScheduleValidation } from 'api/post';
import { getValidationMessagesCount } from 'app/modules/posts/modules/detail/utils/getValidationMessagesCount';
import { PostDetail } from 'types/PostDetail';

type Props = {
  postPreviewData: PostDetail | undefined;
  scheduleValidationMessages: PostScheduleValidation['messages'] | undefined;
  error: boolean | string;
  isLoading: boolean;
  accordionProps?: Partial<React.ComponentProps<typeof AccordionWidget>>;
};

const PostCompletion: FC<Props> = ({
  scheduleValidationMessages,
  postPreviewData,
  isLoading,
  error,
  accordionProps,
}) => {
  const validationMessagesCount = getValidationMessagesCount(
    scheduleValidationMessages,
  );

  if (
    postPreviewData?.status === STATUS.POSTED ||
    postPreviewData?.status === STATUS.SCHEDULED ||
    postPreviewData?.status === STATUS.EXPORTED ||
    postPreviewData?.page.isDemo ||
    validationMessagesCount === 0
  ) {
    return null;
  }

  return (
    <AccordionWidget
      id="posts-preview_completion"
      data-name="posts-preview_completion"
      icon={<AccordionWidgetIcon variant="postCompletion" />}
      title={<AccordionWidgetTitle variant="postCompletion" />}
      titleSuffix={(isOpen) =>
        !isOpen &&
        scheduleValidationMessages && (
          <Chip variant="alert">{validationMessagesCount}</Chip>
        )
      }
      {...accordionProps}
    >
      {isLoading && <Skeleton height={60} />}
      {!!error && (
        <ErrorLoadingDetailProperty>
          {typeof error === 'string' ? error : undefined}
        </ErrorLoadingDetailProperty>
      )}
      {scheduleValidationMessages && postPreviewData && (
        <div className="tw-space-y-2">
          {scheduleValidationMessages.errors.map((todo, i) => (
            <TodoItem
              type="danger"
              key={i}
              post={postPreviewData}
              todo={todo}
            />
          ))}
          {scheduleValidationMessages.warnings.map((todo, i) => (
            <TodoItem
              type="warning"
              key={i}
              post={postPreviewData}
              todo={todo}
            />
          ))}
        </div>
      )}
    </AccordionWidget>
  );
};

export default PostCompletion;
